// src/modules/admin/hooks/useAdminData.js
import { useState, useEffect, useCallback } from 'react';
import { useService } from '../../../shared/hooks/useService';

export function useAdminData() {
    const service = useService();
    const [stats, setStats] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const [lastFetched, setLastFetched] = useState(null);

    const fetchStats = useCallback(async () => {
        setIsLoading(true);
        setError(null);
        try {
            const data = await service.getAdminStats();
            setStats(data);
            setLastFetched(new Date());
        } catch (err) {
            setError(err.message || 'Failed to fetch admin stats');
        } finally {
            setIsLoading(false);
        }
    }, [service]);

    useEffect(() => {
        fetchStats();
    }, [fetchStats]);

    return { stats, isLoading, error, refetch: fetchStats, lastFetched };
}
